// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1Fu74","content":"RecentSearches_content__1bvOl"};